<template>
    <div>
        <div class="row">
            <div class="table-responsive col-12">
                <table class="table table-dark table-hover table-striped table-bordered">
                    <thead>
                    <tr>
                        <th scope="col" v-for="(th, key) in column" :key="key" :class="th.class">{{ th.title }}</th>
                        <th v-if="show.visible || update.visible || remove.visible">AÇÃO</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                    <tr v-for="(row, key) in filteredData" :key="key">
                        <td v-for="(value, keyValue) in row" :key="keyValue" :class="column[keyValue].class" >

                                <span v-if="column[keyValue].type === 'string'" >{{ value }}</span>
                                <span v-if="column[keyValue].type === 'integer'" > {{ value }} </span>
                                <span v-if="column[keyValue].type === 'currency'">{{ value }}</span>
                                <span v-if="column[keyValue].type === 'date'">{{ value | formateGlobalDate }}</span>
                                <span v-if="column[keyValue].type === 'datetime'">{{ value | formateGlobalDateTime }}</span>
                                <span v-if="column[keyValue].type === 'image'">
                                    <img :src="'/storage/'+value" width="30" height="30">
                                </span>
                        </td>
                        <td v-if="show.visible || update.visible || remove.visible">
                            <div class="d-flex gap-3">
                                <button v-if="show.visible && show.target === 'modal'"
                                        class="btn btn-outline-primary btn-sm" data-bs-toggle="modal"
                                        :data-bs-target="show.dataBsTarget" @click="setStore(row)">
                                    Visualizar
                                </button>
                                <button v-if="update.visible && update.target === 'modal'"
                                        class="btn btn-outline-warning btn-sm" data-bs-toggle="modal"
                                        :data-bs-target="update.dataBsTarget" @click="setStore(row)">
                                    <font-awesome-icon icon="fa-solid fa-pen-to-square"/>
                                </button>
                                <button v-if="remove.visible && remove.target === 'modal'"
                                        class="btn btn-outline-danger btn-sm" data-bs-toggle="modal"
                                        :data-bs-target="remove.dataBsTarget" @click="setStore(row)">
                                    <font-awesome-icon icon="fa-solid fa-trash-can"/>
                                </button>

                                <button v-if="show.visible && show.target === 'self'" class="btn btn-outline-primary btn-sm"
                                        @click="openPage('show', row)">
                                    Visualizar
                                </button>
                                <button v-if="update.visible && update.target === 'self'"
                                        class="btn btn-outline-warning btn-sm" @click="openPage('update', row)">
                                    <font-awesome-icon icon="fa-solid fa-pen-to-square"/>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableComponent",
    props: ['data', 'column', 'update', 'remove', 'show', 'urlShow', 'urlUpdate'],
    methods: {
        setStore(row) {
            this.$store.state.transaction.status = ''
            this.$store.state.transaction.message = ''
            this.$store.state.transaction.data = ''
            this.$store.state.item = row
        },

        openPage(action, row){
            let url = '';
            if(action === 'show'){
               url = this.urlShow+'/'+row.id
            }
            if(action === 'update'){
                url = this.urlUpdate+'/'+row.id
            }
        }
    },
    computed: {
        filteredData() {
            let fields = Object.keys(this.column)
            let rows = [];

            this.data.map((item, key) => {
                let row = {};
                fields.forEach(field => {
                    row[field] = item[field]
                })
                rows.push(row)
            })
            return rows
        }
    }
}
</script>

<style scoped>

</style>
